import {Injectable} from '@angular/core';
import {MetricDto, MetricGroupDto} from '../../../../../../pages/geospatial-viewer/layers/metric-layer';

@Injectable({providedIn: 'root'})
export class MeasureMetricService {
    public getDefaultMeasure(measures: MetricGroupDto[]): MetricGroupDto {
        // TODO: new DTO has no default property...
        // Else find first non-disabled measure
        return measures.filter((measure: MetricGroupDto) => measure.enabled)[0];
    }

    public getDefaultMetric(measure: MetricGroupDto): MetricDto {
        // TODO: new DTO has no default property...
        // Else find first non-disabled measure
        return measure.metrics.filter((metric: MetricDto) => metric.enabled)[0];
    }

    public getMeasureByMeasureKey(measureKey: string, measures: MetricGroupDto[]): MetricGroupDto {
        return measures.find((measure: MetricGroupDto) => measure.key === measureKey);
    }

    public getMeasureByMetricKey(metricKey: string, measures: MetricGroupDto[]): MetricGroupDto {
        return measures.find((measure: MetricGroupDto) =>
            measure.metrics.map((metric: MetricDto) => metric.key).includes(metricKey),
        );
    }

    public getMetricFromMetricKey(metricKey: string, measures: MetricGroupDto[]): MetricDto {
        const measure: MetricGroupDto = this.getMeasureByMetricKey(metricKey, measures);
        return measure.metrics.find((metric: MetricDto) => metric.key == metricKey);
    }
}
